// List of route smoothness
const routeSmoothness = [
  'impassable',
  'very_horrible',
  'horrible',
  'very_bad',
  'bad',
  'intermediate',
  'good',
  'excellent'
]

export default routeSmoothness
